<template>
  <div class="plaintext-inner-wrap centered-wrap">

    <component
      v-for="(obj, key, idx) in data"
      :is="obj.color === 'grad' ? 'GradTextFragment' : 'TextFragment'"
      :key="idx"
      :tag="key === 'title' ? 'h3' : 'p'"
      :data="obj"
      :wrap-width="w"
      v-if="obj.txt"
    />

  </div>
</template>

<script>
  import { Bus } from '@/lib/consts'
  import GradTextFragment from '@/components/report/content/GradTextFragment'
  import TextFragment from '@/components/report/content/TextFragment'
  import ContentMixin from '@/components/report/mixins/ContentMixin'

  export default {
    name: 'PlainText',
    mixins: [ ContentMixin ],
    data () {
      return {
        w: Math.min( 600, window.innerWidth )
      }
    },
    created () {
      Bus.$on( 'resized', () => {
        this.w = this.$el.clientWidth
      } )
    },
    mounted () {
      this.w = this.$el.clientWidth
    },
    components: {
      TextFragment,
      GradTextFragment
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/the_goods";

  .plain-text-elem {
    margin-top    : 0;
    margin-bottom : rem(30);
  }

  .sub {
    line-height : 1.4;

    &.adobe-clean-xbold {
      letter-spacing : 0.1431em;
      line-height    : 2.1875;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/PlainText.vue